import { GenericService, getApiUrlPath, IProductSpecificationRequest, IProductSpecificationResponse } from "@/models";


export class ProductSpecificationFactory extends GenericService<IProductSpecificationRequest,
  IProductSpecificationResponse> {
  constructor() {
    super({
      prefix: getApiUrlPath("ProductSpecification")
    });
  }
}

